import React from "react";
import { motion } from "framer-motion";

const ServiceIntroSection = ({ heading, paragraph1, paragraph2 }) => {
  return (
    <section className="svc-intro-text">
      <div className="container-custom">
        <motion.div
          className="svc-intro-text-inner"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <h2>{heading}</h2>
          {paragraph1 && <p>{paragraph1}</p>}
          {paragraph2 && <p>{paragraph2}</p>}
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceIntroSection;
